"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
const react_1 = __importDefault(require("react"));
const react_components_1 = require("@cimpress/react-components");
exports.Loading = ({ message }) => {
    const { Spinner } = react_components_1.shapes;
    return (react_1.default.createElement("div", { style: { display: 'flex', paddingBottom: '20px' } },
        react_1.default.createElement("div", { style: { flexGrow: 1, paddingRight: '20px' } },
            react_1.default.createElement(Spinner, { size: 'medium' })),
        react_1.default.createElement("div", { style: { flexGrow: 1000, lineHeight: '38px' } }, message)));
};
//# sourceMappingURL=Loading.js.map